import { createSlice } from '@reduxjs/toolkit';
import { routeConstant } from 'shared/routes/RouteConstant';

const initState = {
    SelectFilterScreen: routeConstant.admin.dashboard.path
};

export const selectFilterScreenSlice = createSlice({
    name: 'SelectFilterScreen',
    initialState: initState,
    reducers: {
        setSelectFilterScreen: (state, action) => {
            let tempObj = { ...state, ...action.payload };
            return tempObj;
        },
        resetSelectFilterScreen: () => initState
    }
});

export const { setSelectFilterScreen, resetSelectFilterScreen } = selectFilterScreenSlice.actions;

export default selectFilterScreenSlice.reducer;
